import classNames from 'classnames'
import * as styles from './empty-composition-bar.css'

type EmptyBarSize = 'small' | 'tiny'

type EmptyBarProps = {
  ariaLabel: string
  size?: EmptyBarSize
}

export const EmptyCompositionBar: React.FC<EmptyBarProps> = ({ ariaLabel, size = 'tiny' }) => {
  return <div className={classNames(styles.base, styles.baseSize[size])} role="status" aria-label={ariaLabel} />
}
